import './styles.scss'
import React from 'react'
import { connect } from 'react-redux'

import ChatChannelWallNodeInfo from '../ChatChannelWallNodeInfo'
import { DraftMessage } from 'components/Chat/ChatChannels/ChatChannelMessage'

const ChatChannelWallMessage = ({ wallMessages, user, isChat, operator, activitiesTypes, toggleDeleteDraftModal, handleEditDraft, handleToggleShowHideDraft }) => {
  return wallMessages.map((message, index) => {
    if (message.messageType === 'normal' && (message.user === user.id || message.user === user._id)) {
      return (
        <ChatChannelWallNodeInfo
          key={index}
          user={user}
          isChat={isChat}
          operator={operator}
          node={message}
          activitiesTypes={activitiesTypes}
        />
      )
    }

    if (message.messageType === 'draft' && message.type === 'chat') {
      return (
        <DraftMessage
          key={index}
          user={user}
          isChat={isChat}
          content={message}
          toggleDeleteDraftModal={toggleDeleteDraftModal}
          handleEditDraft={handleEditDraft}
          handleToggleShowHideDraft={handleToggleShowHideDraft}
        />
      )
    }

    return null
  })
}

export default connect()(ChatChannelWallMessage)
